import { request } from '@langlois/request';

export async function getByUserId ({ commit }) {
	try {
		const url = new URL(`${process.env.VUE_APP_API_URI}/club/club`);
		url.search = new URLSearchParams({
			isAffiliated: true
		}).toString();

		const response = await request.get(url);

		if (response.ok) {
			const clubs = await response.json();

			commit(`clubs`, clubs);
		}
	} catch (error) {
		return commit(`vcl/notificationBar/show`, {
			text: `Encountered an error while retrieving the clubs.`,
			type: `warning`
		}, { root: true });
	}
}
